import { jsx as t } from "react/jsx-runtime";
import { createContext as o, useContext as d } from "react";
const e = o(void 0), s = (r) => /* @__PURE__ */ t(e.Provider, { value: r, children: r.children });
s.displayName = "BreadCrumbsProvider";
const n = () => {
  const r = d(e);
  if (r === void 0)
    throw new Error("useBreadCrumbs must be used within a BreadCrumbsProvider");
  return r.breadCrumbs;
};
export {
  e as BreadCrumbsContext,
  s as BreadCrumbsProvider,
  n as useBreadCrumbs
};
